import { z } from "zod";
import type { ConditionalCtaContent } from "./contentItemSchemas";
import {
  conditionalCtaFieldsSchema,
  conditionalCtaOptionSchema,
  nestedCtaSchema,
  parseConditionalCtaFromFields,
  parseWithRecord,
} from "./schemas";
import { isRecord } from "./shared";

const conditionalOptionRowSchema = z.object({
  condition: z
    .union([z.string(), z.undefined(), z.null(), z.any()])
    .transform((v) => (typeof v === "string" ? v : "")),
  cta: z.any(),
});

export const parseConditionalCta = (
  item: unknown,
  formLabel?: string,
): ConditionalCtaContent => {
  const parsed = parseWithRecord(item, conditionalCtaFieldsSchema);
  const options: z.output<typeof conditionalCtaOptionSchema>[] = [];
  for (const row of parsed.options) {
    if (!isRecord(row)) continue;
    const r = parseWithRecord(row, conditionalOptionRowSchema);
    const cta = nestedCtaSchema.safeParse(r.cta);
    if (!cta.success) continue;
    options.push({ condition: r.condition, cta: cta.data });
  }
  return parseConditionalCtaFromFields(
    { formLabel: parsed.formLabel, options },
    formLabel,
  );
};
